import React from "react";
import { Grid, Tab, Tabs } from "@material-ui/core";
import ProfileField from "./ProfileField/ProfileField";
import { Values } from "@src/Tools/Values";
import { inject, observer } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STGrid, STProfileFieldsWrapper, STPageHeader } from "./styles";
import { computed, observable } from "mobx";
import { IManagementStore } from "@src/Stores/Management/types";
import { Organisation } from "@src/Interfaces/Entity/Organisation";
import AssociatedAccounts from "./AssociatedAccounts/AssociatedAccounts";
import { STFormContentWrapper, STTabsContentWrapper } from '../../Main/Content/OAuth/styles';
import AuthApiTokens from '../../Main/Content/OAuth/AuthApiTokens/AuthApiTokens';

const xs = 12;
const sm = 12;
const md = 12;

interface IProps {
  auth?: IAuthStore;
  management?: IManagementStore;
}

@inject("auth", "management")
@observer
export default class Profile extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  @observable tabIndex: number = 0;
  @observable profileDetailsTabIndex: number;
  @observable apiTokensTabIndex: number;

  @computed get organisation() {
    if (this.props.management.activeOrganisations.length === 0) {
      return "";
    } else {
      const orgResult: Organisation = this.props.management.activeOrganisations.find(
        (org: Organisation) => org.id === this.props.auth.user.person.organisation
      );
      return orgResult ? orgResult.name : "";
    }
  }

  handleTabIndexChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.tabIndex = newValue;
  };


  async componentDidMount() {
    await this.props.management.getActiveOrganisations();
    this.isLoading = false;
    this.profileDetailsTabIndex = 0;
    this.apiTokensTabIndex = 1;
    document.title = Values.getLocalizationValue("profile");
  }

  render() {
    if (this.isLoading) {
      return <div />;
    }
    return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <STPageHeader>{Values.getLocalizationValue("profile")}</STPageHeader>
        </Grid>
        <Grid item>
        <STTabsContentWrapper>
          <Tabs
            value={this.tabIndex}
            onChange={this.handleTabIndexChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label={Values.getLocalizationValue("details")} />
            <Tab label={Values.getLocalizationValue("apiTokens")} />
          </Tabs>
          <STFormContentWrapper>
            {this.tabIndex === this.profileDetailsTabIndex && this.props.auth.user.location.primary && (
              <STProfileFieldsWrapper>
              <STGrid container justify="center" alignItems="center">
                <Grid item xs={xs} sm={sm} md={md}>
                  <ProfileField label={Values.getLocalizationValue("name")} value={this.props.auth.user.person.name} />
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                  <ProfileField
                    label={Values.getLocalizationValue("fullName")}
                    value={this.props.auth.user.person.fullName}
                  />
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                  <ProfileField label={Values.getLocalizationValue("organisation")} value={this.organisation} />
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                  <ProfileField label={Values.getLocalizationValue("email")} value={this.props.auth.user.person.email} />
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                  <ProfileField label={Values.getLocalizationValue("email")} value={this.props.auth.user.person.email} />
                </Grid>
              </STGrid>
  
              <AssociatedAccounts />
            </STProfileFieldsWrapper>
            )}
            {this.tabIndex === this.apiTokensTabIndex && (
              <div>
                <AuthApiTokens />
              </div>
            )}
          </STFormContentWrapper>
        </STTabsContentWrapper>
        </Grid>
      </Grid>
    );
  }
}
